import ApplicationStatus from './ApplicationStatus';

export const getFormattedDate = (time) => {
  let today = '';
  if (typeof time === 'undefined') {
    today = new Date();
  } else {
    today = new Date(time);
  }

  let dd = today.getDate();

  let mm = today.getMonth() + 1;
  const yyyy = today.getFullYear();
  if (dd < 10) {
    dd = `0${dd}`;
  }

  if (mm < 10) {
    mm = `0${mm}`;
  }
  today = `${mm}/${dd}/${yyyy}`;

  return today;
};
export const convertTimeObjToMin = (obj) => {
  let timeInMin = 0;
  if (typeof obj.years !== 'undefined' && obj.years !== 0) {
    const x = obj.years * 365 * 24 * 60;
    timeInMin += x;
  }
  if (typeof obj.months !== 'undefined' && obj.months !== 0) {
    const x = obj.months * 30 * 24 * 60;
    timeInMin += x;
  }
  if (typeof obj.days !== 'undefined' && obj.days !== 0) {
    const x = obj.days * 24 * 60;
    timeInMin += x;
  }
  if (typeof obj.hours !== 'undefined' && obj.hours !== 0) {
    const x = obj.hours * 60;
    timeInMin += x;
  }
  if (typeof obj.minutes !== 'undefined' && obj.minutes !== 0) {
    const x = obj.minutes;
    timeInMin += x;
  }
  return timeInMin;
};
export const getFormattedAppTime = (timer) => {
  const order = {
    years: null,
    months: null,
    days: null,
    hours: null,
    minutes: null,
  };
  const timerObj = Object.assign(order, timer);
  const readme = Object.keys(timerObj)
    .filter((k) => k !== 'seconds' && k !== 'milliseconds')
    .map(
      (k) =>
        `${timerObj[k]?.toString() === '0' ? '' : `${timerObj[k]}${k[0]}`}`,
    )
    .join(' ');
  return readme;
};
export const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};
export const secondsToString = (seconds) => {
  let value = seconds;

  const units = {
    m: 30 * 24 * 60 * 60,
    d: 24 * 60 * 60,
    h: 60 * 60,
    min: 60,
  };

  const result = [];
  // eslint-disable-next-line
  for (const name in units) {
    const p = Math.floor(value / units[name]);

    if (p === 1) result.push(` ${p} ${name}`);
    if (p >= 2) result.push(` ${p} ${name}`);
    value %= units[name];
  }

  return result;
};
export const numFormatter = (num) => {
  if (num > 100 && num < 300) {
    return '100+';
  }
  if (num > 300 && num < 500) {
    return '300+';
  }
  if (num >= 500 && num < 1000) {
    return '500+';
  }
  if (num >= 1000 && num < 5000) {
    return '1K+';
  }
  if (num >= 5000 && num < 10000) {
    return '5K+';
  }
  if (num >= 10000 && num < 30000) {
    return '10K+';
  }
  if (num >= 30000 && num < 50000) {
    return '30K+';
  }
  if (num >= 50000 && num < 100000) {
    return '50K+';
  }
  if (num >= 100000 && num < 500000) {
    return '100K+';
  }
  if (num >= 500000 && num < 1000000) {
    return '500K+';
  }
  if (num >= 1000000) {
    return '1M+';
  }
  return `${num}+`;
};
export const formatDate = (time) => {
  let formattedDate;
  // Checking the type of time and formatting it accordingly: if it is a string, it is already formatted(previously stored in formatted form)
  if (typeof time !== 'number') {
    formattedDate = time;
  } else {
    formattedDate = getFormattedDate(time);
  }
  return formattedDate;
};

const sortByKey = (objects, key, transformFunction) => {
  const valueA = transformFunction
    ? transformFunction(objects[0][key])
    : objects[0][key];
  const valueB = transformFunction
    ? transformFunction(objects[1][key])
    : objects[1][key];
  return valueB - valueA;
};

const getLatestTimestamp = (timestamps, key) => {
  const lastTimestamp = timestamps[timestamps.length - 1];
  return new Date(lastTimestamp[key]);
};

export const getSortConditions = (a, b) => {
  let sortCondition = 0;
  switch (a.status) {
    case ApplicationStatus.TODO:
      sortCondition = sortByKey([a, b], 'creationTime');
      break;
    case ApplicationStatus.IN_PROGRESS:
      sortCondition =
        getLatestTimestamp(b?.timestamps?.inProgress, 'start') -
        getLatestTimestamp(a?.timestamps?.inProgress, 'start');
      break;
    case ApplicationStatus.REVIEW:
      sortCondition =
        getLatestTimestamp(b?.timestamps?.inProgress, 'end') -
        getLatestTimestamp(a?.timestamps?.inProgress, 'end');
      break;
    default:
      // Handle other statuses
      sortCondition = sortByKey([a, b], 'logBook', (logBook) =>
        convertToTimestamp(logBook[logBook.length - 1]?.dateTime),
      );
  }

  return sortCondition;
};

const convertToTimestamp = (time) => {
  let timeInMilliSeconds;
  if (typeof time === 'number') {
    timeInMilliSeconds = time;
  } else {
    //  the format is DD/MM/YYYY.
    const parts = time.split('/');
    const date = new Date(parts[2], parts[1] - 1, parts[0]);
    timeInMilliSeconds = date.getTime();
  }
  return timeInMilliSeconds;
};
